'use client';
import { makeVar } from '@nerdwallet/apollo';
import { RewardableEventType } from '@lib/types/nerdwallet-plus-rewards';

// Queue of events that resulted in a reward to display to a user
export const nwPlusEphemeralAlertQueueVar = makeVar<
  Set<{
    eventType: RewardableEventType;
    rewardPoints: number;
  }>
>(new Set());
